import React from 'react'
import { Helmet } from 'react-helmet'

// Adds VideoObject JSON LD data to head tag if the embedUrl is from youtube
export default function VideoObjectSchema({
  name, description, thumbnailUrl, uploadDate, duration, embedUrl 
}) {
  if (!embedUrl || !embedUrl.includes('https://www.youtube.com/embed/')) return null

  if (embedUrl.startsWith('<iframe')) embedUrl = embedUrl.split('src="')[1].split('"')[0].split('?')[0]
  else embedUrl = embedUrl.split('?')[0]

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name,
    description,
    thumbnailUrl: [thumbnailUrl || `https://i.ytimg.com/vi_webp/${embedUrl.substring(embedUrl.lastIndexOf('/') + 1)}/hqdefault.webp`],
    uploadDate,
    duration: formatVideoDuration(duration),
    embedUrl
  }

  return (
    <Helmet>
      <script type='application/ld+json'>{JSON.stringify(jsonLd)}</script>
    </Helmet>
  )
}

// Formats the video duration into required format (ie. ISO 8601 format)
function formatVideoDuration(duration) {
  if (!duration) return undefined
  duration = duration.toLowerCase()

  let formattedDuration = 'PT'
  if (duration.includes('hour')) formattedDuration += `${duration.match(/\d/g).join('')  }H`
  if (duration.includes('minutes')) formattedDuration += `${duration.match(/\d/g).join('')  }M`
  if (duration.includes('sec')) formattedDuration += `${duration.match(/\d/g).join('')  }S`

  return formattedDuration
}